import axios, { AxiosRequestHeaders } from 'axios'

import { getConnectionUrl } from './utils'

export interface IResponse<Data> {
  message: string
  data: Data
}

export interface IGetApi<TParams> {
  path: string
  params?: TParams
  headers?: AxiosRequestHeaders
}

export interface IPostApi<TBody> {
  path: string
  body: TBody
  headers?: AxiosRequestHeaders
}

export const apiGet = async <TParams, TResponse>({
  path,
  params,
  headers,
}: IGetApi<TParams>): Promise<IResponse<TResponse>> => {
  const url = getConnectionUrl(path)

  const { data } = await axios.get<IResponse<TResponse>>(url, { params, headers, withCredentials: true })

  return data
}

export const apiPost = async <TBody, TResponse>({
  path,
  body,
  headers,
}: IPostApi<TBody>): Promise<IResponse<TResponse>> => {
  const url = getConnectionUrl(path)

  const { data } = await axios.post<IResponse<TResponse>>(url, body, { headers, withCredentials: true })

  return data
}
